import { isAfter, isValid } from "date-fns";
import { format } from "date-fns/format";

export namespace CommentHelpers {
  /**
   * Returns a formatted string for the number of new comments
   * @param {number} value - The number of comments
   * @returns The formatted string
   */
  export function getCommentCountText(value: number): string {
    return `${value} new comment${value !== 1 ? "s" : ""}`;
  }

  /**
   * Returns a formatted string for the input timestamp in the format d MMM - 5 Jan
   * @param {string} timestamp - The timestamp in format 2024-04-22T14:38:23.368Z
   * @returns
   */
  export function getFormattedDate(timestamp: string, showTime?: boolean, editedDate?: string): string {
    if (typeof timestamp === "undefined" && typeof editedDate === "undefined") {
      return "No date";
    }

    if (showTime) {
      if (editedDate) {
        return `Edited ${format(new Date(editedDate), "d MMM • HH:mm")}`;
      }

      return format(new Date(timestamp), "d MMM • HH:mm");
    }

    if (editedDate) {
      return `Edited ${format(new Date(editedDate), "d MMM")}`;
    }

    return format(new Date(timestamp), "d MMM");
  }

  /*************  ✨ Codeium Command ⭐  *************/
  /**
   * Returns a formatted role display string based on the provided role and optional mentor title.
   * @param {string} role - The role of the individual, e.g., "Mentor", "Mentee", "OO".
   * @param {string} [mentorTitle] - An optional title for the mentor role.
   * @returns {string} - A string representation of the role, with the mentor title if applicable.
   */

  /******  14e62845-b47b-440b-9335-799a63f4e38e  *******/
  export function getRoleDisplayString(role: string, mentorTitle?: string): string {
    switch (role) {
      case "Mentee":
        return "";
      case "Mentor":
        return mentorTitle ? ` - ${mentorTitle}` : " - Mentor";
      case "OO":
        return " - OO (Operational Officer)";
      default:
        return ` - ${role}`;
    }
  }
  /**
   * Checks whether the timestamp is after the read time to display new message indicators
   * @param {string} commentTimestamp - The timestamp the comment was sent in format 2024-04-22T14:38:23.368Z
   * @param {string} readTimestamp - The timestamp the comments were read in format 2024-04-22T14:38:23.368Z
   * @returns
   */
  export function isNewComment(commentTimestamp: string, readTimestamp: string | undefined): boolean {
    if (commentTimestamp == null || readTimestamp == null) {
      return false;
    }

    return (
      isValid(new Date(commentTimestamp)) &&
      isValid(new Date(readTimestamp)) &&
      isAfter(new Date(commentTimestamp), new Date(readTimestamp))
    );
  }
}
